import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilisateurService } from './utilisateur.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EtiquettePilotageModel } from 'src/models/pilotage/etiquettePilotageModel';
import { CreerEtiquetteModel } from 'src/models/pilotage/creerEtiquetteModel';
import { ModifierEtiquetteModel } from 'src/models/pilotage/modifierEtiquetteModel';
import { SupprimerEtiquetteModel } from 'src/models/pilotage/supprimerEtiquetteModel';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class EtiquetteService {

  private baseUrl = environment.api_LMS + 'Etiquette';

  constructor(private http: HttpClient, private utilisateurService: UtilisateurService, private translateService: TranslateService) { }

  obtenirEtiquettes(): Observable<EtiquettePilotageModel[]> {
    return this.http.get<EtiquettePilotageModel[]>(`${this.baseUrl}/ObtenirEtiquettes`, { params: { entiteId: this.utilisateurService.entiteUtilisateurSelectionnee.entiteId, utilisateurId: this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId } });
  }

  creerEtiquette(model: CreerEtiquetteModel): Observable<any> {
    return this.http.post(`${this.baseUrl}/CreerEtiquette`, model);
  }

  modifierEtiquette(model: ModifierEtiquetteModel): Observable<any> {
    return this.http.put(`${this.baseUrl}/ModifierEtiquette`, model);
  }

  supprimerEtiquettes(model: SupprimerEtiquetteModel): Observable<any> {
    return this.http.put(`${this.baseUrl}/SupprimerEtiquettes`, model);
  }

  exporterEtiquettes(etiquetteIds: number[], codeLangue: string): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/Exporter`, etiquetteIds, {
      responseType: 'blob',
      params: { codeLangue }
    });
  }

  exporterEtiquettesPdf(etiquetteIds: number[], codeLangue: string): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/ExporterPdf`, etiquetteIds, {
      responseType: 'blob',
      params: { codeLangue }
    });
  }

  obtenirUtilisateursParEtiquette(etiquetteId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/ObtenirUtilisateursParEtiquette`, {
      params: {
        etiquetteId: etiquetteId.toString(),
        entiteId: this.utilisateurService.entiteUtilisateurSelectionnee.entiteId.toString(),
        utilisateurId: this.utilisateurService.entiteUtilisateurSelectionnee.utilisateurId.toString()
      }
    });
  }

  getNomLocalise(locales: { [key: string]: string }): string {
    const currentLang = this.translateService.currentLang || 'fr';
    if (locales[currentLang] && locales[currentLang].trim()) {
      return locales[currentLang];
    }
    for (const key of Object.keys(locales)) {
      if (locales[key] && locales[key].trim()) {
        return locales[key];
      }
    }
    return '';
  }

  obtenirCouleur(hexColor: string): string {
    hexColor = hexColor.replace('#', '');
    const r = parseInt(hexColor.substr(0, 2), 16);
    const g = parseInt(hexColor.substr(2, 2), 16);
    const b = parseInt(hexColor.substr(4, 2), 16);

    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance > 0.5 ? '#000000' : '#FFFFFF';
  }
}
